import { useQuery } from '@tanstack/react-query';
import { fetchJobById, fetchSimilarJobs, type JobDetail } from '../api/jobs';

export function useJobDetailQuery(jobSlug?: string) {
  return useQuery({
    queryKey: ['job-detail', jobSlug],
    queryFn: async () => {
      if (!jobSlug) return undefined;
      return fetchJobById(jobSlug);
    },
    enabled: Boolean(jobSlug),
    staleTime: 1000 * 60,
  });
}

export function useSimilarJobsQuery(jobSlug?: string, enabled = true) {
  return useQuery({
    queryKey: ['job-similar', jobSlug],
    queryFn: async () => {
      if (!jobSlug) return [];
      return fetchSimilarJobs(jobSlug);
    },
    enabled: Boolean(jobSlug) && enabled,
    staleTime: 1000 * 60,
  });
}

export type { JobDetail };
